// @ts-expect-error not typed
import TypingIndicator from 'conversations-visitor-message-history/typing-indicator/TypingIndicatorMessage';
import AvailabilityMessage from 'conversations-visitor-message-history/availability/AvailabilityMessage';
// @ts-expect-error not typed
import ActivelyPublishingMessage from 'conversations-visitor-message-history/publishing/ActivelyPublishingMessage';
// @ts-expect-error not typed
import FeedbackSurveyMessage from 'conversations-visitor-message-history/feedback-survey-message/FeedbackSurveyMessage';

// @ts-expect-error not typed
import ConnectedEmailCapturePromptMessage from '../containers/connected-messages/ConnectedEmailCapturePromptMessage';
// @ts-expect-error not typed
import ConnectedFailedToPublishMessage from '../containers/connected-messages/ConnectedFailedToPublishMessage';
// @ts-expect-error not typed
import ConnectedInitialMessage from '../containers/connected-messages/ConnectedInitialMessage';
import ConnectedCommonMessage from '../containers/connected-messages/ConnectedCommonMessage';
import { withConsent } from '../connectors/withConsent';
// @ts-expect-error not typed
import ConnectedDateLabel from '../containers/connected-messages/ConnectedDateLabel';
import { supportedMessageTypes } from './supportedMessageTypes';
// @ts-expect-error not typed
import { withSessionId } from '../connectors/withSessionId';
// @ts-expect-error not typed
import { withHubspotUtk } from '../connectors/withHubspotUtk';
import { withThreadId } from '../connectors/withThreadId';
import { withGates } from '../connectors/withGates';
import { withTypingIndicatorStyle } from '../connectors/withTypingIndicatorStyle';
const {
  ACTIVELY_PUBLISHING,
  COMMON_MESSAGE,
  PARTIAL_MESSAGE,
  DATE_MESSAGE,
  EMAIL_CAPTURE_PROMPT,
  FAILED_TO_PUBLISH,
  INITIAL_MESSAGE,
  OFFICE_HOURS,
  TYPICAL_RESPONSE_TIME,
  TYPING,
  FEEDBACK_SURVEY,
  CUSTOMER_AGENT_MAINTENANCE_MODE_MESSAGE,
  CUSTOMER_AGENT_AUTOMATED_MESSAGE
} = supportedMessageTypes;
const CommonAndPartialMessage = withGates(withConsent(ConnectedCommonMessage));
export const MessageHistoryConfig = {
  [ACTIVELY_PUBLISHING]: ActivelyPublishingMessage,
  [COMMON_MESSAGE]: CommonAndPartialMessage,
  [PARTIAL_MESSAGE]: CommonAndPartialMessage,
  [DATE_MESSAGE]: ConnectedDateLabel,
  [EMAIL_CAPTURE_PROMPT]: ConnectedEmailCapturePromptMessage,
  [FAILED_TO_PUBLISH]: ConnectedFailedToPublishMessage,
  [INITIAL_MESSAGE]: withConsent(ConnectedInitialMessage),
  [OFFICE_HOURS]: AvailabilityMessage,
  [TYPICAL_RESPONSE_TIME]: AvailabilityMessage,
  [TYPING]: withTypingIndicatorStyle(TypingIndicator),
  [FEEDBACK_SURVEY]: withThreadId(withSessionId(withHubspotUtk(FeedbackSurveyMessage))),
  [CUSTOMER_AGENT_MAINTENANCE_MODE_MESSAGE]: CommonAndPartialMessage,
  [CUSTOMER_AGENT_AUTOMATED_MESSAGE]: CommonAndPartialMessage
};